import React from "react";

export function InstagramOutlined({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 3C8.83248 3 3 8.83248 3 16V34C3 41.1675 8.83248 47 16 47H34C41.1675 47 47 41.1675 47 34V16C47 8.83248 41.1675 3 34 3H16ZM16 5H34C40.0865 5 45 9.91352 45 16V34C45 40.0865 40.0865 45 34 45H16C9.91352 45 5 40.0865 5 34V16C5 9.91352 9.91352 5 16 5ZM37 11C36.4696 11 35.9609 11.2107 35.5858 11.5858C35.2107 11.9609 35 12.4696 35 13C35 13.5304 35.2107 14.0391 35.5858 14.4142C35.9609 14.7893 36.4696 15 37 15C37.5304 15 38.0391 14.7893 38.4142 14.4142C38.7893 14.0391 39 13.5304 39 13C39 12.4696 38.7893 11.9609 38.4142 11.5858C38.0391 11.2107 37.5304 11 37 11ZM25 14C18.9367 14 14 18.9367 14 25C14 31.0633 18.9367 36 25 36C31.0633 36 36 31.0633 36 25C36 18.9367 31.0633 14 25 14ZM25 16C29.9824 16 34 20.0176 34 25C34 29.9824 29.9824 34 25 34C20.0176 34 16 29.9824 16 25C16 20.0176 20.0176 16 25 16Z"
        fill="currentColor"
      />
    </svg>
  );
}
